var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            { staticClass: "cardClassDetailForm passwordChangeArea" },
            [
              _c("template", { slot: "card-title-custom" }, [
                _c("div", { staticClass: "titleArea" }, [
                  _c(
                    "div",
                    { staticClass: "title" },
                    [
                      _vm._v(" 경농 EHS Partner "),
                      _c("font", { staticClass: "emphasis" }, [
                        _vm._v("접속 아이디를"),
                      ]),
                      _vm._v(" 변경 해 주세요.”"),
                      _c("br"),
                      _vm._v(" 사업자번호 아이디는 사용할 수 없습니다. "),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-label-text", {
                      staticStyle: { "padding-bottom": "25px !important" },
                      attrs: {
                        title: "기존 아이디",
                        value: _vm.portalInfo.loginId,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: true,
                        label: "변경할 아이디 - (영문+숫자 조합 5자리 이상)",
                        name: "portalId",
                        type: "text",
                      },
                      model: {
                        value: _vm.portalInfo.portalId,
                        callback: function ($$v) {
                          _vm.$set(_vm.portalInfo, "portalId", $$v)
                        },
                        expression: "portalInfo.portalId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                    staticStyle: { "text-align": "right" },
                  },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          attrs: { label: "아이디 변경", icon: "save" },
                          on: { btnClicked: _vm.saveId },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }